
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import _ from 'lodash'

window.Vue = Vue
window.BootstrapVue = BootstrapVue
Vue.use(BootstrapVue)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('doughnut-component', require('./components/DoughnutComponent.vue').default);
Vue.component('horizontal-bar-component', require('./components/HorizontalBarComponent.vue').default);
Vue.component('activities-progress-component', require('./components/ActivitiesProgressComponent.vue').default);

Vue.component('revenue-chart-component', require('./components/RevenueChartComponent.vue').default);
Vue.component('daily-registrations-component', require('./components/DailyRegistrationsComponent.vue').default);
Vue.component('amilia-transactions-component', require('./components/AmiliaTransactionsComponent.vue').default);
Vue.component('amilia-franchisee-settlements-component', require('./components/AmiliaFranchiseeSettlementsComponent.vue').default);

Vue.component('datacandy-weekly-monthly-component', require('./components/datacandy/DatacandyWeeklyMonthlyComponent.vue').default);

// TODO: Move to helpers.js file
_.getObjectFromLocalStorage = function(key) {
  let o = null
  try {
    o = window.localStorage[key] ? JSON.parse(window.localStorage[key]) : null
  } catch(error) {}
  return o
}

_.toastError = function(component, error) {
  component.$bvToast.toast(error, {
    title: trans('error'),
    variant: 'danger',
    solid: true,
  })
}

_.errorFromAjax = function(error) {
  let result = null
  if (error && error.response && error.response.data) {
    result = error.response.data.errors ? _.values(error.response.data.errors).join(' ') : error.response.data.message
  } else {
    result = error
  }
  if (!result) result = trans('unexpected_error')
  return result;
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
});

